<template>
  <div class="file-list">
    <div
      v-if="!files || files.length === 0"
      class="text-muted text-center py-4"
    >
      Aucun fichier à afficher
    </div>
    <div
      v-for="file in files"
      :key="file.id"
      class="file-list-item d-flex align-items-center justify-content-between p-2 mb-2 border rounded bg-white shadow-sm"
    >
      <div class="d-flex align-items-center flex-grow-1">
        <i
          :class="fileIconClass(file.type)"
          class="me-3 fs-2x text-primary"
        ></i>
        <div>
          <div class="fw-bold file-name" :title="file.name">
            {{ truncate(file.name) }}
          </div>
          <!-- <div class="small text-muted">
            <span v-if="file.size">{{ formatSize(file.size) }} • </span>
            <span v-if="file.createdAt">{{ formatDate(file.createdAt) }}</span>
          </div> -->
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button
          class="btn btn-sm btn-primary me-2"
          @click="download(file)"
          :title="'Télécharger ' + file.name"
        >
          <i class="fad fa-file-download"></i>
        </button>
        <!-- <button
          class="btn btn-sm btn-danger"
          @click="$emit('remove', file)"
          :title="'Supprimer ' + file.name"
        >
          <i class="fad fa-trash"></i>
        </button> -->
      </div>
    </div>

    <template v-if="hasRole('ROLE_MANAGER')">
      <FileUpload text="Ajouter un fichier" @fileUploaded="addFile" />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import Asset from "@/entity/Asset";
import FileUpload from "./FileUpload.vue";
import { api } from "@/services/Api";

@Component({
  components: {
    FileUpload,
  },
})
export default class FileList extends Vue {
  @Prop({ default: () => [] }) readonly files!: Asset[];
  @Prop({ default: () => "" }) readonly contract!: string;
  @Prop({ default: () => "" }) readonly avenant!: string;

  fileIconClass(type?: string) {
    if (!type) return "fad fa-file";
    const t = type.toLowerCase();
    if (t.includes("pdf")) return "fad fa-file-pdf text-danger";
    if (t.includes("image")) return "fad fa-file-image text-success";
    if (t.includes("word")) return "fad fa-file-word text-primary";
    if (t.includes("excel") || t.includes("spreadsheet"))
      return "fad fa-file-excel text-success";
    if (t.includes("zip") || t.includes("rar"))
      return "fad fa-file-archive text-warning";
    if (t.includes("audio")) return "fad fa-file-audio text-info";
    if (t.includes("video")) return "fad fa-file-video text-info";
    if (t.includes("text") || t.includes("plain"))
      return "fad fa-file-alt text-secondary";
    return "fad fa-file";
  }

  truncate(name: string, max = 30) {
    if (!name) return "";
    if (name.length <= max) return name;
    return name.substring(0, max - 8) + "..." + name.substring(name.length - 5);
  }

  formatSize(size: number) {
    if (!size) return "";
    if (size < 1024) return size + " o";
    if (size < 1024 * 1024) return (size / 1024).toFixed(1) + " Ko";
    if (size < 1024 * 1024 * 1024)
      return (size / (1024 * 1024)).toFixed(1) + " Mo";
    return (size / (1024 * 1024 * 1024)).toFixed(1) + " Go";
  }

  formatDate(date: any) {
    if (!date) return "";
    const d = typeof date === "string" ? new Date(date) : date;
    return d.toLocaleDateString();
  }

  async download(file: Asset) {
    // Si file.src est un lien direct, on peut faire un download simple
    if (file.src) {
      const link = document.createElement("a");
      link.href = file.src;
      link.download = file.name || "fichier";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Sinon, émettre un événement pour que le parent gère le téléchargement
      this.$emit("download", file);
    }
  }

  async addFile(file: any) {
    console.log(file, 'file')
    if (file) {
      const res = await api.post(api.core, "file/edit", {
        src: file.link,
        contract: this.contract,
        name: file.file.file.name,
        avenant: this.avenant,
      });

      if (res && res.data) {
        this.$emit("added", res.data);
      }
    }
  }


}
</script>

<style scoped>
.file-list {
  max-width: 600px;
  margin: 0 auto;
}
.file-list-item {
  transition: box-shadow 0.15s;
}
.file-list-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: #f8fafd;
}
.file-name {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>